import { ISelectOption } from '@aon/aon-tws-common-ui';
import styled from 'styled-components';
import { IPageFlowElementModalProps } from '../components/pages/logic-and-layout/page-flow/PageFlowElementModal';
import { IPageFlowElementModel, ISurveyQuestionEditModel } from '../models';
import { SurveyDesignHelper } from './';

const HandleClose = (setDefaultState: () => void, onClose: () => void) => {
	onClose();
	setDefaultState();
};

const HandleEffect = (
	props: IPageFlowElementModalProps,
	setQuestionId: React.Dispatch<React.SetStateAction<string>>,
	setQuestionError: React.Dispatch<React.SetStateAction<boolean>>,
	setSurveyElement: React.Dispatch<React.SetStateAction<IPageFlowElementModel>>,
) => {
	setQuestionError(false);
	setQuestionId(InitializeQuestion(props));
	if (props.pageFlowElement) {
		setSurveyElement({ ...props.pageFlowElement });
	} else {
		setSurveyElement(InitializeSurveyElement(props));
	}
};

const HandleQuestionChange = (
	value: any,
	setQuestionId: React.Dispatch<React.SetStateAction<string>>,
	setQuestionError: React.Dispatch<React.SetStateAction<boolean>>,
) => {
	setQuestionId(value);
	setQuestionError(false);
};

const HandleSubmit = (
	props: IPageFlowElementModalProps,
	questionId: string,
	surveyElement: IPageFlowElementModel,
	setQuestionError: React.Dispatch<React.SetStateAction<boolean>>,
	setSurveyElement: React.Dispatch<React.SetStateAction<IPageFlowElementModel>>,
	isValid: (questionId: string, setQuestionError: React.Dispatch<React.SetStateAction<boolean>>) => boolean,
	increment?: number,
) => {
	if (isValid(questionId, setQuestionError) || increment !== undefined) {
		const surveyElements: IPageFlowElementModel[] = [];
		let maxId: number = props.maxId;
		let numElementsAdded = 0;
		let followupQuestionCount = 0;
		if (increment !== undefined) {
			for (let i = +increment + 1; i <= props.questions.length; i = i + +increment) {
				const newElement: IPageFlowElementModel = InitializeSurveyElement(props, maxId);
				if (props.questions[i - 1].parentQuestionId) {
					followupQuestionCount++;
					newElement.sequence = i + followupQuestionCount + +numElementsAdded;
				} else {
					newElement.sequence = i + followupQuestionCount + +numElementsAdded;
				}
				surveyElements.push(newElement);
				maxId++;
				numElementsAdded++;
			}
		} else {
			const questionIdInt = parseInt(questionId, 10);
			const beforeAfterElement = props.questions.find((q) => q.id === questionIdInt);
			const beforeAfterElementSequence = beforeAfterElement?.sequence === undefined ? 0 : beforeAfterElement.sequence;
			const originalSequence: number | undefined = props.pageFlowElement?.sequence;
			setSurveyElement(SurveyDesignHelper.UpdateExistingElement(surveyElement, beforeAfterElementSequence, originalSequence));
			surveyElements.push(surveyElement);
		}
		props.onSubmit(surveyElements);
	}
};

const InitializeQuestion = (props: IPageFlowElementModalProps) => {
	const selectedQuestion = props.questions.find((q) => {
		return props.pageFlowElement?.sequence ? q.sequence === props.pageFlowElement.sequence + 1 : false;
	});
	return selectedQuestion ? selectedQuestion.id.toString() : '';
};

const InitializeQuestionList: (props: IPageFlowElementModalProps, removeFirstQuestion: boolean) => ISelectOption[] = (
	props: IPageFlowElementModalProps,
	removeFirstQuestion: boolean,
) => {
	const questionSelectOptions: ISelectOption[] = props.questions
		.filter((q) => !q.parentQuestionId)
		.map((q: ISurveyQuestionEditModel) => {
			const text = q.displayOrder + '. ' + q.text;
			return { name: q.id.toString(), displayText: text, displayOrder: q.sequence };
		});

	if (removeFirstQuestion) {
		// remove the first question
		questionSelectOptions.splice(0, 1);
	}

	return questionSelectOptions;
};

const InitializeSurveyElement = (props: IPageFlowElementModalProps, maxId?: number) => {
	return SurveyDesignHelper.AddNewElement(
		maxId !== undefined ? maxId : props.maxId,
		props.elementType,
		props.defaultCultureCode,
		props.availableCultures,
		props.supportedCultures,
	);
};

const IsValid = (questionId: string, setQuestionError: React.Dispatch<React.SetStateAction<boolean>>) => {
	if (questionId === '') {
		setQuestionError(true);
		return false;
	}

	return true;
};

const PageFlowContainer = styled.div.attrs<{}>({
	className: 'tws-page-flow-container',
})`
	width: 80%;
	margin: auto;
`;
PageFlowContainer.displayName = 'PageFlowContainer';

const SetDefaultState = (
	props: IPageFlowElementModalProps,
	setQuestionId: React.Dispatch<React.SetStateAction<string>>,
	setQuestionError: React.Dispatch<React.SetStateAction<boolean>>,
	setSurveyElement: React.Dispatch<React.SetStateAction<IPageFlowElementModel>>,
	setQuestionList: React.Dispatch<React.SetStateAction<ISelectOption[]>>,
	removeFirstQuestion: boolean,
) => {
	HandleQuestionChange('', setQuestionId, setQuestionError);
	setSurveyElement(InitializeSurveyElement(props));
	setQuestionList(InitializeQuestionList(props, removeFirstQuestion));
};

export const PageFlowElementModalUtil = {
	HandleClose,
	HandleEffect,
	HandleQuestionChange,
	HandleSubmit,
	InitializeQuestion,
	InitializeQuestionList,
	InitializeSurveyElement,
	IsValid,
	PageFlowContainer,
	SetDefaultState,
};
